$(window).on('load', () => {
  // Prevent double execution with namespace check
  if (window.GrinderApp && window.GrinderApp.initialized) {
    return;
  }

  // Initialize your app
  window.GrinderApp = window.GrinderApp || {};
  window.GrinderApp.initialized = true;
  console.log('-------------------load-------------------');
  
  // For jdgm product Page only
  const jdgmForm = document.querySelector(".jdgm-form-wrapper");
  const jdgmBody = document.querySelector(".jdgm-rev-widg__body");
  const jdgmActions = document.querySelector(".jdgm-widget-actions-wrapper");
  if(jdgmForm && jdgmBody && jdgmActions) {
    // jdgmBody.append(jdgmForm, jdgmActions);
  }

const menuHeadings = document.querySelectorAll(".mobile-submenu__list .mega-menu__section .mega-menu .container .mega-menu__block .menu__heading");
  const menuListHeadings = document.querySelectorAll(".mobile-menu__list .mobile-menu__list-item .mobile-menu__item");
  const mainMenuHeadings = document.querySelectorAll(".mobile-menu .mobile-menu__item");
  const loginButton = document.querySelector(".customer-area .mobile-menu__item_user");
  const backIcon = document.querySelector(".mobile-menu .customer-area .open-menu-wrapper");
  const mobileListMenu = document.querySelector(".mobile-menu__content .mobile-menu__list");
  const registerWrapper = document.querySelector(".mobile-menu__content .auth-sign-up");
  const loginWrapper = document.querySelector(".mobile-menu__content .auth-log-in");
  const signUpButton = document.querySelector(".auth-wrapper .account-area a");
  const haveAccountButton = document.querySelector(".auth-wrapper .have-account a");
  const closeMenu = document.querySelector(".mobile-menu__toggle-button");
  const closeSidebar = document.querySelector(".mobile-menu.in-top .mobile-menu__toggle-icon .mobile-header__close-menu");
  const hasMegamenu = document.querySelectorAll(".mega-menu__section.small-megamenu");
  const tabHeading = document.querySelectorAll(".tab-item .tab-heading");
  const slidesCount = document.querySelector(".custom-instagram .fs-wrapper .fs-timeline");
  const productNextButton = document.querySelector(".product-gallery__thumbnails .flickity-prev-next-button.next");
  const productPrevButton = document.querySelector(".product-gallery__thumbnails .flickity-prev-next-button.previous");
  const openSidebar = document.querySelector(".filter-action");
  const searchResultWrapper = document.querySelector(".page__content.content.container .snize.snize-search-results");
  const firstElementMobile = document.querySelectorAll(".mobile-menu.in-top .mobile-menu__list .mobile-menu__list-item");
  const checkBoxMenu = document.querySelectorAll(".mobile-menu.in-top .mobile-menu__list .mobile-menu__list-item .submenu__input");
  if(checkBoxMenu) {
    checkBoxMenu.forEach((element, index) => {
      element.addEventListener('change', (e) => {
        if(e.target.checked){
          checkBoxMenu.forEach((el, index) => {
            el.checked = false;
          })
          e.target.checked = true;
        } else {
          e.target.checked = false;
        }
      })
    })
  }
  // if(firstElementMobile) {
  //   firstElementMobile.forEach((first, index) => {
  //     if(index == 0) {
  //       first.querySelector(".visually-hidden.submenu__input").checked = true
  //     }
  //   })
  // }
  if(closeSidebar) {
    closeSidebar.addEventListener('click', () => {
      if(firstElementMobile) {
        firstElementMobile.forEach((first, index) => {
          if(first.querySelector("input[type=checkbox]") && index != 0) {
            first.querySelector("input[type=checkbox]").checked = false
          } else {
          if(index == 0) {
            first.querySelector("input[type=checkbox]").checked = true
          }
        }
        })
      }
    })
  }
  if(openSidebar) {
    openSidebar.addEventListener('click', () => {
      // document.querySelector(".collection__content .sidebar-section").classList.add("sidebar-open");
      $('.collection__main').toggleClass('filter-open')
      // document.querySelector('.collection-filters-overlay').style.display = 'block';
      // setTimeout(() => {
      //   document.querySelector('html').style.overflow = 'hidden';
      // }, 300)
    })
    document.querySelector('.collection-filters-overlay').addEventListener('click', (e) => {
      // e.target.style.display = 'none';
      $('.collection__main').removeClass('filter-open')
      // setTimeout(() => {
      //   document.querySelector('html').style.overflow = 'auto';
      // }, 300)
    })
    document.querySelector('.collection__content .sidebar-section .sidebar-header svg').addEventListener('click', (e) => {
      // document.querySelector(".collection__content .sidebar-section").classList.remove("sidebar-open");
      $('.collection__main').removeClass('filter-open')
      // document.querySelector('.collection-filters-overlay').style.display = 'none';
      // setTimeout(() => {
      //   document.querySelector('html').style.overflow = 'auto';
      // }, 1000)
    })
  }
  if(slidesCount && slidesCount.children.length < 4) {
    document.querySelector('.custom-instagram').style.display = 'none';
    document.querySelector('.heading-without-margin').style.display = 'none';
  }
  // if(slidesCount && slidesCount.children.length <= 4) {
  //   slidesCount.style.gridTemplateColumns = "repeat("+slidesCount.children.length+",1fr)"
  // }

  const btnApply = document.querySelector('.btn-apply');
  const ambasadorWelcome = document.querySelector('.ambasador-welcome-section');
  const ambasadorForm = document.querySelector('.ambasador-form-section');
  const ambasadorPolicy = document.querySelector('.ambasador-policy-section');
  const termsBtn = document.querySelector('.open-term-desktop');
  const termsBtnMobile = document.querySelector('.open-term-mobile');
  if(btnApply) {
    btnApply.addEventListener('click', () => {
      ambasadorWelcome.style.display = "none"
      ambasadorForm.style.display = "block"
      ambasadorPolicy.style.display = "none"
    })
  }
  if(termsBtn) {
    termsBtn.addEventListener('click', () => {
      ambasadorWelcome.style.display = "none"
      ambasadorForm.style.display = "none"
      ambasadorPolicy.style.display = "block"
    })
  }
  if(termsBtnMobile) {
    termsBtnMobile.addEventListener('click', () => {
      ambasadorWelcome.style.display = "none"
      ambasadorForm.style.display = "none"
      ambasadorPolicy.style.display = "block"
    })
  }
  //  Will need that later for search
  if(searchResultWrapper) {
    //searchResultWrapper.innerHTML += '<div class="filter-button"><div class="filter-action is-flex is-align-center is-justify-space-between" id="SearchButton"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"> <circle id="Ellipse_181" data-name="Ellipse 181" cx="30" cy="30" r="30"></circle> <g id="Group_487" data-name="Group 487" transform="translate(-85 -210)"> <path id="Path_340" data-name="Path 340" d="M62.555,69.639h0A2.261,2.261,0,0,0,60,69.8c-.244.168-.479.352-.728.548-.221.173-.449.352-.688.522a8.243,8.243,0,0,1-7.333,1.294l-1.666-.473c-1.548-.439-3.148-.893-4.72-1.355a19.337,19.337,0,0,0-5.322-1.073,14,14,0,0,0-9.763,3.925,2.049,2.049,0,0,0-.478,1.072,1.687,1.687,0,0,0,1,1.871,2.225,2.225,0,0,0,2.543-.155c.248-.172.486-.358.738-.556.217-.17.442-.347.676-.514a8.316,8.316,0,0,1,4.911-1.665,8.732,8.732,0,0,1,2.418.354c.685.2,1.372.39,2.058.583,1.558.437,3.17.89,4.743,1.389,5.643,1.795,10.363.895,14.429-2.75a2.662,2.662,0,0,0,.731-1.394A1.6,1.6,0,0,0,62.555,69.639ZM30.3,52.492h0a2.225,2.225,0,0,0,2.544-.155c.248-.171.486-.358.739-.556.217-.17.442-.346.676-.514A8.316,8.316,0,0,1,39.169,49.6a8.722,8.722,0,0,1,2.418.354c.683.2,1.368.389,2.053.581,1.56.438,3.173.891,4.748,1.391,5.643,1.794,10.362.894,14.429-2.75a2.662,2.662,0,0,0,.731-1.393,1.6,1.6,0,0,0-.992-1.779A2.259,2.259,0,0,0,60,46.161c-.244.168-.48.352-.729.548-.221.173-.449.352-.688.522a8.243,8.243,0,0,1-7.333,1.295l-1.662-.472c-1.549-.439-3.152-.894-4.724-1.356a19.619,19.619,0,0,0-5.322-1.073A14.053,14.053,0,0,0,29.78,49.55a2.048,2.048,0,0,0-.478,1.072A1.686,1.686,0,0,0,30.3,52.492Zm32.255,5.355A2.26,2.26,0,0,0,60,58c-.244.168-.48.352-.729.548-.221.173-.449.352-.688.522a8.241,8.241,0,0,1-7.333,1.294L49.59,59.9c-1.549-.439-3.152-.894-4.724-1.356a19.887,19.887,0,0,0-5.322-1.073,14.061,14.061,0,0,0-9.763,3.925,2.049,2.049,0,0,0-.478,1.072,1.687,1.687,0,0,0,1,1.871,2.224,2.224,0,0,0,2.543-.156c.248-.172.487-.359.739-.557.217-.17.441-.346.675-.513a8.316,8.316,0,0,1,4.911-1.665,8.722,8.722,0,0,1,2.418.354c.682.2,1.365.388,2.048.58,1.562.438,3.176.892,4.753,1.393,5.643,1.794,10.363.894,14.429-2.75a2.66,2.66,0,0,0,.731-1.394A1.6,1.6,0,0,0,62.555,57.847Z" transform="translate(68.728 177.377)" fill="aqua"></path> <g id="Group_486" data-name="Group 486"> <g id="Ellipse_180" data-name="Ellipse 180" transform="translate(118.306 223)" stroke="aqua" stroke-width="3"> <circle cx="5" cy="5" r="5" stroke="none"></circle> <circle cx="5" cy="5" r="3.5" fill="none"></circle></g> <g id="Ellipse_182" data-name="Ellipse 182" transform="translate(118.306 247)" stroke="aqua" stroke-width="3"> <circle cx="5" cy="5" r="5" stroke="none"></circle> <circle cx="5" cy="5" r="3.5" fill="none"></circle></g> <g id="Ellipse_183" data-name="Ellipse 183" transform="translate(101.306 232.5)" stroke="aqua" stroke-width="3"> <circle cx="5" cy="5" r="5" stroke="none"></circle> <circle cx="5" cy="5" r="3.5" fill="none"></circle></g></g></g></svg>filter</div></div>';
    searchResultWrapper.innerHTML += '<input id="inputSearch" class="input snize-input-style" type="search" name="q" placeholder="What are you looking for?">'
  }
  if(hasMegamenu) {
    hasMegamenu.forEach(parent => {
    if(parent.closest(".navbar-item.header__item")) {
      parent.closest(".navbar-item.header__item").style.position = "relative"
    }
    })
  }
  if(closeMenu) {
    closeMenu.addEventListener('click', (e) => {
      e.preventDefault()
      loginButton.style.display = "flex"
      backIcon.style.display = "none"
      mobileListMenu.style.display = "block"
      registerWrapper.style.display = "none"
      loginWrapper.style.display = "none"
    })
  }
  if(menuHeadings) {
    menuHeadings.forEach(item => {
      item.addEventListener('click', () => {
        item.closest('.mega-menu__linklist').classList.toggle('is-open')
      })
    })
  }
  if(mainMenuHeadings) {
    mainMenuHeadings.forEach(item => {
      item.addEventListener('click', (e) => {
        if(e.target.nextSibling) {
        }
      })
    })
  }
  if(menuListHeadings) {
    menuListHeadings.forEach(menuList => {
      menuList.addEventListener('click', (e) => {
        console.log(e.target);
        if(e.target.nextSibling)
        e.target.nextSibling?.click()
      })
    })
  }
  if(loginButton) {
    loginButton.addEventListener('click', (e) => {
      e.preventDefault()
      backIcon.style.display = "flex"
      loginButton.style.padding = "0"
      mobileListMenu.style.display = "none"
      registerWrapper.style.display = "none"
      loginWrapper.style.display = "block"
      loginButton.style.display = "none"
    })
  }
  if(backIcon) {
    backIcon.addEventListener('click', () => {
      loginButton.style.display = "flex"
      backIcon.style.display = "none"
      mobileListMenu.style.display = "block"
      registerWrapper.style.display = "none"
      loginWrapper.style.display = "none"
    })
  }
  if(signUpButton) {
    signUpButton.addEventListener('click', (e) => {
      e.preventDefault()
      mobileListMenu.style.display = "none"
      loginWrapper.style.display = "none"
      registerWrapper.style.display = "block"
    })
  }
  if(haveAccountButton) {
    haveAccountButton.addEventListener('click', (e) => {
      e.preventDefault()
      mobileListMenu.style.display = "none"
      loginWrapper.style.display = "block"
      registerWrapper.style.display = "none"
    })
  }
  const prevBtns = document.querySelectorAll(".reviews-count .btn-actions .prev")
  const nextBtns = document.querySelectorAll(".reviews-count .btn-actions .next")
  let lastPage = 0
  if(document.querySelector(".jdgm-paginate__page.jdgm-paginate__last-page")) {
    setTimeout(() => {
      lastPage = parseInt(document.querySelector(".jdgm-paginate__page.jdgm-paginate__last-page").getAttribute('data-page'));
    }, 999)
  }
  let lastIndex = 1;
  function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }
  const itemHeading = document.querySelectorAll(".faq-elements-wrapper .faq-item");
  // Create a media condition that targets viewports at least 768px wide
  const minMediaQuery = window.matchMedia('(min-width: 769px)')
  const maxMediaQuery = window.matchMedia('(max-width: 768px)')
  if(itemHeading.length > 0) {
  itemHeading[0].classList.add('active')
    itemHeading.forEach(item => {
      item.addEventListener('click', (e) => {
        itemHeading.forEach(el => {
          el.classList.remove('active')
        })
        e.target.classList.add('active');
        let position ;

        if (minMediaQuery.matches) {
          position = getOffset(document.getElementById(item.getAttribute('data-item'))).top - 120
        }
        if (maxMediaQuery.matches) {
          position = getOffset(document.getElementById(item.getAttribute('data-item'))).top - 80
        }

        $("body, html").animate({
          scrollTop: position
        }, 1000);
      })
    })
  }
  
  if (maxMediaQuery.matches) {
    console.log('matched')
    if (productNextButton && productPrevButton) {
      productNextButton.innerHTML = '<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="bxs-up-arrow-circle" d="M11,19a8,8,0,1,0-8-8A8.009,8.009,0,0,0,11,19ZM11,7l4,4H11.8v4H10.2V11H7Z" transform="translate(19 -3) rotate(90)" fill="#dadedf"/></svg>';
      productPrevButton.innerHTML = '<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="bxs-up-arrow-circle" d="M11,19a8,8,0,1,0-8-8A8.009,8.009,0,0,0,11,19ZM11,7l4,4H11.8v4H10.2V11H7Z" transform="translate(-3 19) rotate(-90)" fill="#dadedf"/></svg>';
    }

    if (document.querySelector(".view-on-judgeme")) {
      $('.view-on-judgeme').click(function() {
        const productHandle = window.location.pathname.split('/').pop();
        const judgeMeUrl = `https://judge.me/reviews/grinder-punch.myshopify.com/products/${productHandle}`;
  
        window.open(judgeMeUrl, '_blank');
      })
    }

    if (document.querySelector(".reviews-badge-container")) {
      document.querySelector(".reviews-badge-container").addEventListener('click', () => {
        window.scrollTo({
          top: document.querySelector('.reviews-tab-item').offsetTop - 126,
          behavior: 'smooth'
        })
        document.querySelector('.reviews-tab-item').classList.add('is-active')
      })
    }
  }
  const instagramItems = document.querySelectorAll(".fs-wrapper.fs-timeline .fs-entry-container");
  if(instagramItems.length === 0) {
    if(document.querySelector(".heading-without-margin"))
    document.querySelector(".heading-without-margin").classList.add('hidden')
    if(document.querySelector(".custom-instagram"))
    document.querySelector(".custom-instagram").classList.add('hidden')
    if(document.querySelector(".simple-heading-section"))
    document.querySelector(".simple-heading-section").classList.add('hidden')
  }
  if (maxMediaQuery.matches) {
    if(instagramItems.length > 0 && instagramItems.length < 2) {
      instagramItems[0].closest('.fs-wrapper').classList.add('hidden')
      if(document.querySelector(".heading-without-margin"))
      document.querySelector(".heading-without-margin").classList.add('hidden')
      if(document.querySelector(".custom-instagram"))
      document.querySelector(".custom-instagram").classList.add('hidden')
      if(document.querySelector(".simple-heading-section"))
      document.querySelector(".simple-heading-section").classList.add('hidden')
    }
  }
  if (minMediaQuery.matches) {
    if(instagramItems.length > 0 && instagramItems.length < 2) {
      instagramItems[0].closest('.fs-wrapper').classList.add('hidden')
      if(document.querySelector(".heading-without-margin"))
      document.querySelector(".heading-without-margin").classList.add('hidden')
      if(document.querySelector(".custom-instagram"))
      document.querySelector(".custom-instagram").classList.add('hidden')
      if(document.querySelector(".simple-heading-section"))
      document.querySelector(".simple-heading-section").classList.add('hidden')
    }
  }
  let searchSidebar = document.querySelector('.sidebar-block__content input[name="q"]')
  if(searchSidebar)
  searchSidebar.addEventListener('keyup', (e)=>{
    if(document.querySelector('.snize-ac-results')){
      document.querySelector('.snize-ac-results').style.display = 'none'
      document.querySelector('.snize-ac-results').style.visibility = 'hidden'
    }
  })
  if (document.querySelector('.cart__checkout .checkout')) {
    const checkoutBtn = document.querySelector('.cart__checkout .checkout')
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault()
      checkIfCartIncludesRXProducts()
    })
  }
  document.addEventListener('CART::Show', () => {
    setTimeout(() => {
      if (document.querySelector('.lv-cart-drawer .cart-footer .btn-checkout')) {
        const btnCheckOut = document.querySelector('.lv-cart-drawer .cart-footer .btn-checkout')
        btnCheckOut.addEventListener('click', (e) => {
          e.preventDefault()
          checkIfCartIncludesRXProducts()
        })
      }
    }, 500)
  })
  const checkIfCartIncludesRXProducts = () => {
    let redirectToCheckout = true
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((item) => {
        if (item.product_type === "Prescription") {
          redirectToCheckout = false
        }
      })
      window.location = !redirectToCheckout ? '/pages/rx-form': '/checkout'
    })
    .catch((e) => {
      window.location = '/checkout'
      console.log(e)
    })
  }
  if (document.querySelectorAll('.rx-product-wrapper img').length > 0) {
    document.querySelectorAll('.rx-product-wrapper img').forEach(img => {
      img.addEventListener('click', () => {
        console.log(img.getAttribute('src'))
        localStorage.setItem('rx-product-selected-lens', img.getAttribute('src'))
      })
    })
  }
})

$('.view-on-judgeme').click(function() {
  const productHandle = window.location.pathname.split('/').pop();
  const judgeMeUrl = `https://judge.me/reviews/grinder-punch.myshopify.com/products/${productHandle}`;

  window.open(judgeMeUrl, '_blank');
})

$('.reviews-badge-container').click(function() {
  console.log('click')
  window.scrollTo({
    top: document.querySelector('.reviews-tab-item').offsetTop - 136,
    behavior: 'smooth'
  })
  document.querySelector('.reviews-tab-item').classList.add('is-active')
})